export const ERROR_MESSAGE =
  'Ocurrió un error inesperado, estamos resolviendo el problema. Vuelve a intentarlo más tarde.';

const ERROR_GINNI_NO_CONTROLADO = 'ginni-000';

interface IErrorService {
  codigo?: string;
  mensaje?: string;
  message?: string;
}

export class APIError {
  status: number;
  codigo: string;
  mensaje = ERROR_MESSAGE;

  constructor(status = 500, error?: IErrorService) {
    this.status = status;

    if (error) {
      this.codigo = error.codigo;

      if (error.codigo === ERROR_GINNI_NO_CONTROLADO) {
        this.mensaje = ERROR_MESSAGE;
      } else {
        if (error.mensaje || error.message) {
          this.mensaje = error.mensaje || error.message;
        } else {
          this.mensaje = ERROR_MESSAGE;
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/@compartidos/models/api-error.model.ts